export const COLUMNS = [
  {
    Header: "FirstName",
    accessor: "FirstName",
  },
  {
    Header: "LastName",
    accessor: "LastName",
  },
  {
    Header: "Start Date",
    accessor: "StartDate",
  },
  {
    Header: "Departement",
    accessor: "Departement",
  },
  {
    Header: "Date of birth",
    accessor: "DateofBirth",
  },
  {
    Header: "Address",
    accessor: "Address",
  },
  {
    Header: "City",
    accessor: "City",
  },
  {
    Header: "State",
    accessor: "State",
  },
  {
    Header: "ZipCode",
    accessor: "ZipCode",
  },
];
